export default __webpack_public_path__ + "static/media/Michael Gates.a1856cb1.jpg";